import request from "@/utils/request.js";

const baseApi = '/auth'

export const apiGetRouter = () => {
    return request({
        url: `${baseApi}/web/router`,
        method: 'get'
    })
}

export const apiLogin = (data) => {
    return request({
        url: `${baseApi}/login`,
        method: 'post',
        data
    })
}

export const apiSetAuthority = (authorityId) => {
    return request({
        url: `${baseApi}/setAuthority`,
        method: 'post',
        params: {
            authorityId
        }
    })
}

export const apiLogout = () => {
    return request({
        url: `${baseApi}/logout`,
        method: 'post'
    })
}


export const apiSendCode = (data) => {
    return request({
        url: '/sendEmailCode',
        method: 'post',
        data
    })
}

export const apiRegister = (data) => {
    return request({
        url: '/register',
        method: 'post',
        data
    })
}

export const apiGetDetail = () => {
    return request({
        url: `${baseApi}/detail`,
        method: 'get'
    })
}